import { FinancialInstitution } from '@yodlee/ycc-settings-widget/dist/types/interfaces/onload';
import React from 'react';
import { Brand, FinancialInstitution as OnloadFinancialInstitutions, Onload } from '../types/interfaces/onload';
import { Permission } from '../types/interfaces/permission';
import { Preferences } from '../types/interfaces/preferences';

interface IApplicationContext {
    preferences?: Preferences,
    onload?: Onload
    permissions?: Array<Permission>,
    userFeatures?: Array<any>,
    selectedBrand: Partial<Brand> & { channel?: FinancialInstitution, isYccEnabled?: boolean },
    setSelectedBrand: (selectedBrand: Partial<Brand> & { channel?: FinancialInstitution }) => void,
    setFinancialInstitutions: (fi: OnloadFinancialInstitutions) => void,
    setPreferences: (preferences: Preferences) => void,
    setUserFeatures: (userFeatures: Array<any>) => void,
}

const Application = React.createContext<IApplicationContext>({
    selectedBrand: {},
    userFeatures: [],
    setSelectedBrand: (selectedBrand: any) => console.debug("Selected brand: ", selectedBrand),
    setFinancialInstitutions: (fi) => console.debug("fi", fi),
    setPreferences: (preferences) => console.debug("preferences", preferences),
    setUserFeatures: (userFeatures: Array<any>) => console.debug("userFeatures", userFeatures),
});


export default Application;